import { ReactNode } from 'react';

interface IndirectTaxSummaryCardProps {
  label: string;
  value: ReactNode;
}

export const IndirectTaxSummaryCard = ({
  label,
  value,
}: IndirectTaxSummaryCardProps) => {
  return (
    <div className="flex flex-col gap-xs p-xl">
      <span className="txt-extra-small-regular text-text-tertiary">
        {label}
      </span>
      <div className="txt-extra-large-medium text-text-primary">{value}</div>
    </div>
  );
};
